import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { config } from '@/services/config';
import { get, map, omitBy } from 'lodash';
import { formatDataValue } from '@/helpers/format';
import { PortfolioTableData, Portfolio } from '@/types/Service';
import { createTableHeaders, createTopTableHeaders } from '@/helpers/tables';
import { translations } from '@/plugins/localisation';
import { getFeatureFlag, FeatureFlag } from '@/services/config';

export type Getters = {
  getPortfolioTableData(state: State): PortfolioTableData;
};

export const getters: GetterTree<State, RootState> & Getters = {
  getPortfolioTableData: state => {
    const portfolioData = state.portfolio.portfolioData;
    const portfolioCount = state.portfolio.portfolioDataCount;

    const clientTableConfig = get(
      config.layout,
      'tableLayouts.servicePortfolioTable',
      {}
    );
    const configTopHeaders = get(clientTableConfig, 'topHeaders', []);
    let configHeaders = get(clientTableConfig, 'mainHeaders', []);

    if (!getFeatureFlag(FeatureFlag.FAMILY_LEVEL_SIMULATED_IMPACT).enabled) {
      configHeaders = omitBy(configHeaders, { key: 'aggregatedFamilyStatus' });
    }

    const items = map(portfolioData, item => {
      let roa = null;
      if ((item.roa.dataValue as number) > 0.1) {
        roa = translations.global.t('general.NOT_DISCLOSED');
      } else {
        roa = formatDataValue(item.roa);
      }
      const transformed = Object.assign(
        {},
        ...Object.entries(item.clientSpecificValues).map(item => ({
          [item[0]]: formatDataValue(item[1]),
        }))
      );
      const mappedItem = {
        aggregatedFamilyStatus: formatDataValue(item.familyStatus),
        serviceLevelWide: formatDataValue(item.serviceLevelWide),
        status: formatDataValue(item.status),
        clientId: formatDataValue(item.clientId),
        portfolioId: formatDataValue(item.portfolioId),
        familyId: formatDataValue(item.familyId),
        aum: formatDataValue(item.aum),
        roa,
        revenue: formatDataValue(item.revenue),
        periodicFees: formatDataValue(item.periodicFees),
        transactionFees: formatDataValue(item.transactionFees),
        totalFees: formatDataValue(item.totalFees),
        priceEnforcement: formatDataValue(item.priceEnforcement),
        profit: formatDataValue(item.profit),
        profitMargin: formatDataValue(item.profitMargin),
        isOpening: formatDataValue(item.isOpening),
        isClosing: formatDataValue(item.isClosing),
        ...transformed,
      } as Portfolio;

      return mappedItem;
    });

    return {
      topHeaders: createTopTableHeaders(configTopHeaders),
      headers: createTableHeaders(configHeaders),
      items: items,
      totalResultCount: portfolioCount,
    };
  },
};
